import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card lh-lg" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "mb-14" }
const _hoisted_4 = { class: "mb-15" }
const _hoisted_5 = { class: "fs-2x text-dark mb-6" }
const _hoisted_6 = { class: "fs-5 text-gray-600 fw-semibold" }
const _hoisted_7 = { class: "mb-20 pb-lg-20" }
const _hoisted_8 = { class: "fw-bold text-dark mb-8" }
const _hoisted_9 = { class: "fs-4 fw-semibold mb-15" }
const _hoisted_10 = { class: "text-gray-700" }
const _hoisted_11 = { class: "text-gray-700" }
const _hoisted_12 = { class: "text-gray-700" }
const _hoisted_13 = { class: "text-gray-700" }
const _hoisted_14 = { class: "text-gray-700" }
const _hoisted_15 = { class: "text-gray-700" }
const _hoisted_16 = { class: "text-gray-700" }
const _hoisted_17 = { class: "fw-bold text-dark mb-7" }
const _hoisted_18 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_19 = { class: "fs-4 fw-semibold text-gray-600 mb-13 px-10 rounded p-5 border border-dashed border-primary bg-light-primary" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "px-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("https://app.inboxino.com/help")
const _hoisted_30 = { class: "fw-bold text-dark mb-7" }
const _hoisted_31 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("https://app.inboxino.com/help")
const _hoisted_33 = { class: "fw-bold text-dark mb-7" }
const _hoisted_34 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("https://app.inboxino.com/services/api")
const _hoisted_36 = { class: "fw-bold text-dark mb-7" }
const _hoisted_37 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_38 = { class: "fw-bold text-dark mb-7" }
const _hoisted_39 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_40 = { class: "fw-bold text-dark mb-7" }
const _hoisted_41 = { class: "fs-4 fw-semibold text-gray-700 mb-13" }
const _hoisted_42 = { class: "fs-4 fw-semibold text-gray-700 mb-13 p-10 border border-dashed border-primary border-3 rounded bg-light-info" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("https://app.inboxino.com/help")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.translate("Introduction of Inboxino services")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.translate(
                "Inboxino WhatsApp assistant is a web-based system that has gained attention due to the increasing use of WhatsApp by people and businesses"
              )) + " " + _toDisplayString(_ctx.translate(
                "Definitely, both you and those around you do a lot of daily affairs, communication, notifications or advertisements on WhatsApp"
              )) + " " + _toDisplayString(_ctx.translate(
                "This large volume in the use of this software has caused many businesses to turn to WhatsApp and transfer their communication with customers, marketing and advertising, customer support to WhatsApp"
              )) + " " + _toDisplayString(_ctx.translate(
                "Since WhatsApp, unlike Telegram, has numerous limitations for wide and mass use, a group of programming and artificial intelligence experts gathered in Inboxino to make the use of WhatsApp easier for businesses and to connect WhatsApp with sites"
              )) + " " + _toDisplayString(_ctx.translate(
                "systems various applications creating automatic answering machines creating stores and queuing systems in WhatsApp as well as sending mass messages in WhatsApp the concern of companies organizations and businesses in using WhatsApp as a message Lets raise the world"
              )), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.translate(
                "As mentioned, Inboxino WhatsApp Assistant provides the following services on the web platform:"
              )), 1),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate("create Autoresponder")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate("Send bulk messages")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(
                  "Connecting WhatsApp to the site through web service (api)"
                )), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate("Creating queuing systems in WhatsApp")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate("Create an online")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate("Customer support in WhatsApp (WhatsApp crm)")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate("Multi-user")), 1)
            ])
          ]),
          _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.translate("create Autoresponder")) + " : ", 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.translate(
                "By creating a Autoresponder on WhatsApp, you can make it easier for you to respond to your customers and audience"
              )) + ". " + _toDisplayString(_ctx.translate(
                "In this way, this autoresponder is programmed and executed 24 hours a day and fully automatically by you and with your own business numbers, and anyone who sends a message to your WhatsApp number will receive a welcome message at first"
              )) + ". " + _toDisplayString(_ctx.translate(
                "or example, consider someone sends a phrase like hello to the WhatsApp number of Inboxino, and the system automatically sends this message to him"
              )) + ". ", 1),
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(_ctx.translate("Greetings and Regards")) + " 🌹 ", 1),
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.translate("Welcome to Inboxino")) + " 🙏 ", 1),
            _hoisted_21,
            _createTextVNode(_toDisplayString(_ctx.translate(
                "Please select the desired number from the menu below to use any of Inboxinos services"
              )) + " : ", 1),
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createTextVNode(" 1- " + _toDisplayString(_ctx.translate("Introducing Inboxino")) + " ", 1),
              _hoisted_25,
              _createTextVNode(" 2- " + _toDisplayString(_ctx.translate("Get Inboxino training videos")) + " ", 1),
              _hoisted_26,
              _createTextVNode(" 3- " + _toDisplayString(_ctx.translate("View tariffs")) + " ", 1),
              _hoisted_27,
              _createTextVNode(" 4- " + _toDisplayString(_ctx.translate("Address and contact number")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createTextVNode(_toDisplayString(_ctx.translate(
                "As you can see you can create a menu and sub-menu in WhatsApp in several steps and after each user selects the desired menu in the form of a complete WhatsApp bot you will have an automatic response within a few seconds and a photo"
              )) + ". " + _toDisplayString(_ctx.translate(
                "Send video, audio and text or any content you have in mind to your contacts"
              )) + ". " + _toDisplayString(_ctx.translate(
                "This Autoresponder is very effective for many organizations companies or even natural persons it can greatly reduce the cost of manpower and waste of time and energy to respond to customers and contacts You can follow the guide for making a Autoresponder in this link"
              )) + ": ", 1),
            _createVNode(_component_router_link, {
              to: "/help",
              target: "_blank",
              class: "link-info mx-5"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.translate("Ability to Send bulk messages:")), 1),
          _createElementVNode("div", _hoisted_31, [
            _createTextVNode(_toDisplayString(_ctx.translate(
                "All businesses and organizations are interested in being able to introduce their brand to thousands or even millions of people either for advertising or for information and to inform their customers and clients of a special offer or news"
              )) + ". " + _toDisplayString(_ctx.translate(
                "Most of the businesses were using text messages or sms before but due to the many limitations of text messages such as many numbers being blocked messages not being read not sending videos photos and audio the bulk sending being expensive and or the lack of proper feedback they prohibit sending messages through SMS"
              )) + ". " + _toDisplayString(_ctx.translate(
                "But the Inboxino system has made it possible for all organizations and businesses to send video photo audio link or text to any number they want to the number of numbers they want"
              )) + ". " + _toDisplayString(_ctx.translate("And this is because of the feedback")) + ". " + _toDisplayString(_ctx.translate(
                "It is high and that more than 90% of the messages are checked by your contacts it can be the best tool for information or advertising and sales"
              )) + ". " + _toDisplayString(_ctx.translate(
                "Of course keep in mind that there is no limit to send any number of messages in the Inboxino system due to time sharing but WhatsApp has limits for numbers that you have not chatted with before and if they report you"
              )) + ". " + _toDisplayString(_ctx.translate(
                "It can and may block your number which of course will return to normal after a few hours or days but before you start sending messages please see the guide and tutorial on how to reduce the risk of being blocked in the link below"
              )) + ". ", 1),
            _createVNode(_component_router_link, {
              to: "/help",
              target: "_blank",
              class: "link-info mx-5"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.translate("Api")), 1),
          _createElementVNode("div", _hoisted_34, [
            _createTextVNode(_toDisplayString(_ctx.translate(
                "Another useful feature of Inboxino is that you can connect your site application or systems to your WhatsApp so that you can automatically send any message you want to your users"
              )) + ". " + _toDisplayString(_ctx.translate(
                "For example sending a confirmation code on WhatsApp to users who are entering your site or sending training videos to customers who are looking for a guide to using your facilities or anyone who sends an article in the chat section of your site can see it on their WhatsApp"
              )) + ". " + _toDisplayString(_ctx.translate(
                "do This feature which is provided to you through the web service or api can also provide you with hundreds of other features such as sending reminders notifications customer crm etc"
              )) + ". " + _toDisplayString(_ctx.translate(
                "To receive and activate the web service after buying the package related to this feature click on the web service option from the side menu"
              )) + ". " + _toDisplayString(_ctx.translate("Enter and save")) + ". " + _toDisplayString(_ctx.translate("As you can see an api key will be provided to you")) + ". " + _toDisplayString(_ctx.translate(
                "From the api documentation section read and execute the required documents"
              )) + ". ", 1),
            _createVNode(_component_router_link, {
              to: "/help",
              target: "_blank",
              class: "link-info mx-5"
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.translate("Creating queuing systems in WhatsApp")), 1),
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.translate(
                "This possibility is very useful for those businesses that run their business through queuing systems"
              )) + ". " + _toDisplayString(_ctx.translate(
                "In this way you provide your WhatsApp number to the customers and after sending a message on WhatsApp they see all the times specified by you and book their appointment on WhatsApp"
              )) + ". " + _toDisplayString(_ctx.translate(
                "Even after booking an appointment they can pay online on WhatsApp"
              )) + ". " + _toDisplayString(_ctx.translate(
                "After booking the appointment a WhatsApp message is sent to the business owner and informs him of the reservation"
              )) + ". " + _toDisplayString(_ctx.translate(
                "This possibility which is considered a rare example in the world is very useful for doctors consultants hairdressers and as mentioned all businesses that are somehow involved in booking appointments"
              )) + ". ", 1),
          _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.translate("Customer support in WhatsApp (WhatsApp crm)")), 1),
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.translate(
                "Since many of our daily interactions and communications happen on WhatsApp it is much easier for both customers and business owners to get support on WhatsApp than on different software"
              )) + ". " + _toDisplayString(_ctx.translate(
                "By connecting CRM systems of businesses to WhatsApp, Inboxino has been able to drastically reduce the costs of answering and communicating with many businesses"
              )) + ". ", 1),
          _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.translate("Multi-user")), 1),
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.translate(
                "Inboxino has made it possible for you to view the messages received from your customers online in Inboxino and send messages to your contacts from the same section"
              )) + ". " + _toDisplayString(_ctx.translate(
                "This feature allows multiple users to respond to customers"
              )) + ". ", 1),
          _createElementVNode("div", _hoisted_42, [
            _createTextVNode(_toDisplayString(_ctx.translate(
                "For information and methods of setting up and using each of the above features you can refer to the following link"
              )) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/help",
              target: "_blank",
              class: "link-info mx-5"
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.translate(
                "Also to answer questions you can call 021-91690322 through ticket online chat and phone number"
              )) + " " + _toDisplayString(_ctx.translate(
                "Also our colleagues are ready to answer your questions on WhatsApp with"
              )) + " wa.me/+989101921481 ", 1)
          ])
        ])
      ])
    ])
  ]))
}